<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
        style="display: flex; justify-content: center"
      >
        <v-row justify="center">
          <v-col cols="12" sm="8" md="4">
            <template v-if="mobsUser">
              <app-logo :src="'img/mobs_violeta.svg'" :alt="'Academia'" />
            </template>

            <template v-else>
              <div class="logo_container">
                <app-logo />
              </div>
            </template>

            <app-spinner
              v-if="
                loading ||
                (accessWithAutologin &&
                  (autologinStatus === 'pending' ||
                    autologinStatus === 'success'))
              "
            />

            <template>
              <div class="notification-error" v-show="error_message">
                <p>
                  Su usuario y/o contraseña no concuerdan. Intente nuevamente
                </p>
              </div>
              <div class="notification-success" v-show="email_sent === true">
                <p>
                  Se ha enviado un correo electrónico a su casilla de correo con
                  los pasos a seguir.
                </p>
              </div>
              <div class="notification-error" v-show="email_sent === false">
                <p>
                  Ha ocurrido un error. Por favor verifique la dirección de
                  correo ingresada.
                </p>
              </div>
            </template>

            <v-card flat tile>
              <v-card-text>
                <v-form v-if="!loading || !accessWithAutologin">
                  <v-text-field
                    @disabled="loading"
                    @change="email_sent = null"
                    @blur="$v.formLogin.username.$touch()"
                    :error="$v.formLogin.username.$error"
                    :error-messages="usernameErrors"
                    v-model="formLogin.username"
                    label="Usuario"
                    name="login"
                    prepend-inner-icon="person"
                    type="text"
                    autofocus
                    outlined
                  />
                  <v-text-field
                    @blur="$v.formLogin.password.$touch()"
                    :error="$v.formLogin.password.$error"
                    :error-messages="passwordErrors"
                    v-model="formLogin.password"
                    id="password"
                    label="Contraseña"
                    name="password"
                    prepend-inner-icon="lock"
                    :type="showPassword ? 'text' : 'password'"
                    outlined
                  >
                    <template v-slot:append>
                      <v-tooltip
                        left
                        :disabled="$vuetify.breakpoint.smAndDown"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            @click="showPassword = !showPassword"
                          >
                            {{ showPassword ? "mdi-eye" : "mdi-eye-off" }}
                          </v-icon>
                        </template>
                        <span>
                          {{
                            showPassword
                              ? "Ocultar contraseña"
                              : "Mostrar contraseña"
                          }}
                        </span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-form>
              </v-card-text>

              <v-card-actions class="actions-container">
                <v-btn
                  v-show="!loading"
                  :disabled="$v.formLogin.$invalid"
                  color="info"
                  @click.prevent="login"
                  width="80%"
                  height="45px"
                  >Iniciar sesión</v-btn
                >
                <br />
                <v-btn
                  v-show="!loading"
                  color="rapired"
                  dark
                  @click.prevent="googleLogin"
                  width="80%"
                  height="45px"
                  >Iniciar sesión con Google</v-btn
                >
                <br />
                <v-btn
                  text
                  v-show="!loading"
                  color="primary"
                  :disabled="!formLogin.username || !!email_sent"
                  @click="recoverPassword"
                  >¿Olvidaste tu contraseña?</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <policy-acceptance-dialog
      v-if="needsPolicyAcceptance"
      @close="handlePolicyClose"
    />
  </v-app>
</template>

<script>
import { auth } from "../plugins/firebase";
import { required, email } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import AppLogo from "../components/Mobs/AppLogo.vue";
import AppSpinner from "../components/Mobs/AppSpinner.vue";
import PolicyAcceptanceDialog from "../components/PolicyAcceptanceDialog.vue";

export default {
  name: "login",
  components: { AppLogo, AppSpinner, PolicyAcceptanceDialog },
  data() {
    return {
      formLogin: {
        username: "",
        password: "",
      },
      error_message: false,
      email_sent: null,
      loading: false,
      showPassword: false,
    };
  },
  computed: {
    mobsUser() {
      return this.$store.state.mobsUser;
    },
    usernameErrors() {
      const errors = [];
      if (!this.$v.formLogin.username.$error) return errors;
      !this.$v.formLogin.username.required &&
        errors.push("El usuario debe ser un email con formato válido");
      !this.$v.formLogin.username.email &&
        errors.push("El usuario debe ser un email con formato válido");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.formLogin.password.$error) return errors;
      !this.$v.formLogin.password.required &&
        errors.push("Ingrese la contraseña");
      return errors;
    },
    autologinStatus() {
      return this.$store.state.auth.autologinStatus;
    },
    accessWithAutologin() {
      return this.$store.getters.signWithLink;
    },
    ...mapGetters(["needsPolicyAcceptance"]),
  },
  validations: {
    formLogin: {
      username: { required, email },
      password: { required },
    },
  },
  methods: {
    ...mapActions({
      signInWithEmailAndPassword: "login",
      signInWithPopUp: "loginWithGoogle",
    }),

    async login() {
      this.loading = true;
      this.error_message = false;
      try {
        await this.signInWithEmailAndPassword({
          email: this.formLogin.username,
          password: this.formLogin.password,
        });
      } catch (error) {
        console.error({ error });
        this.error_message = true;
      } finally {
        this.loading = false;
      }
    },

    async googleLogin() {
      this.loading = true;
      this.error_message = false;
      try {
        await this.signInWithPopUp();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    getTechnicianByUID(uid) {
      let baseURL = JSON.parse(localStorage.getItem("baseURL"));
      this.axios
        .get(`technician_by_uid/${uid}/`)
        .then((response) => {
          const technician = response.data;
          localStorage.setItem("technician", JSON.stringify(technician));
        })
        .catch(() => {
          this.error_message = true;
          alert("ERROR");
          console.log("error en getTechnicianByUID: " + uid);
        });
    },

    recoverPassword() {
      const _this = this;

      auth
        .sendPasswordResetEmail(this.formLogin.username)
        .then(function () {
          _this.email_sent = true;
        })
        .catch(function (error) {
          _this.email_sent = false;
          console.log(error);
        });
    },

    handlePolicyClose() {
      this.$store.commit("setNeedsPolicyAcceptance", false);
    },
  },
};
</script>

<style scoped>
.actions-container {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
}

.notification-error,
.notification-success {
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 1rem;
  padding-top: 1rem;
  font-size: 1em;
  color: #ffffff;
  border-radius: 25px;
}
.notification-error {
  background-color: #d1602b;
}
.notification-success {
  background-color: #25c025d2;
}
.logo_container {
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
